import { getOrderHistory, getOrderById } from 'shared/models/api';

const ORDER_HISTORY_LOADED = 'ORDER_HISTORY_LOADED';
const ORDER_HISTORY_LOADING = 'ORDER_HISTORY_LOADING';
const ORDER_LOADED = 'ORDER_LOADED';
const ORDER_LOADING = 'ORDER_LOADING';

const init = {
  count: 0,
  orders: [],
  order: {},
  ordersLoading: false,
  orderLoading: false
};

export default function(state = init, action = {}) {
  switch (action.type) {
    case ORDER_HISTORY_LOADING:
      return { ...state, ordersLoading: true };
    case ORDER_HISTORY_LOADED:
      return {
        ...state,
        count: action.count,
        orders: (state.orders || []).concat(action.orders),
        ordersLoading: false
      };
    case ORDER_LOADING:
      return { ...state, orderLoading: true };
    case ORDER_LOADED:
      return { ...state, order: action.order, orderLoading: false };
    default:
      return state;
  }
}

export function loadOrderHistory(opts = {}) {
  return (dispatch, getState) => {
    if (getState().orderHistory.ordersLoading) return;
    dispatch({ type: ORDER_HISTORY_LOADING });
    return getOrderHistory(opts).then(res => {
      const count = res.count || 0;
      const orders = res.orders || [];
      dispatch({ type: ORDER_HISTORY_LOADED, orders, count });
    });
  };
}

export function loadOrder(id) {
  return (dispatch, getState) => {
    if (getState().orderHistory.orderLoading) return;
    dispatch({ type: ORDER_LOADING });
    return getOrderById(id).then(order => {
      dispatch({ type: ORDER_LOADED, order });
    });
  };
}
